import React from 'react';
import { makeStyles } from '@material-ui/styles';
import AutoCompleteAddress from './AutoCompleteAddress';
import List from '@material-ui/core/List';
import {useState, useEffect, useRef} from 'react'

import PanelButtons from './PanelButtons';
import { Divider,  Paper, Typography } from '@material-ui/core';

import OutputAddress from './OutputAddress';
import WarnningBox from './WarnningBox';

import {getDistance} from '../hooks/orders-fees'; 
import CoordinatesView from './CoordinatesView';
import { Loader } from "@googlemaps/js-api-loader"
import { log } from '../hooks/debug';
import { getCurrentGeoLocation, getBoundingBox } from '../hooks/geo-location';

const useStyles = makeStyles((theme) => ({

  containerPage:{
   
  },
  paddingSearch: {
  backgroundColor:"red",
   // height: "110vh",
  },

  containerSearch:{
  
    width: "94%",
    marginLeft: '3%', 
    marginRight: '3%', 
    marginTop: theme.spacing(2),

    [theme.breakpoints.up('md')]: {
      top: "30vh",
      left: "30%",
      width: "40%",
      padding:  theme.spacing(2),
    },
   //backgroundColor: "red",
  },

  containerAddress:{
    position: "fixed",
    top: 0,
    width: "94%",
    marginLeft: '3%', 
    marginRight: '3%', 
    marginTop: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      padding:  theme.spacing(2),
      width: "35%",
    },
   
  },

  containerFormButtons:{ 
     position: "fixed",
     bottom: 0,
     width: "100%",
    [theme.breakpoints.up('md')]: {
      //bottom: "10vh",
      left: "30%",
      width: "40%",
      padding:  theme.spacing(2),
    },
    //backgroundColor:"blue",
  },

  containerHelp: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems:'center',
    backgroundColor:'blue',
    height: '50vh',
   },
   helpText: {
    marginRight:theme.spacing(0.5)
   },
   helpIcon: {
    marginRight:theme.spacing(0.5)
   },

   containerError:{
    marginLeft: '3%', 
    marginRight: '3%',
    [theme.breakpoints.up('md')]: {
     
      width: "40%",
      padding:  theme.spacing(2),
    },
  },

  containerAddressList:{
    width: "94%",
    marginLeft: '3%', 
    marginRight: '3%',
    marginTop: '3%',
    padding:  theme.spacing(1),
   
    [theme.breakpoints.up('md')]: {
      //bottom: "10vh",
      left: "30%",
      width: "40%",
      padding:  theme.spacing(2),
    },
  },
  divider:{
    marginBottom: theme.spacing(2), 
    marginTop: theme.spacing(2), 
 },

 titleList: {
  textTransform: 'uppercase',
  fontSize: '0.8rem',
  marginTop: theme.spacing(1), 
  marginBottom: theme.spacing(1), 
  marginLeft: theme.spacing(1)
 },
 list: {
  overflow:'auto',
  maxHeight: '60vh',
 },


 scrollable: {
  marginBottom: "80vh", 
 },


}));



const defaultStrings = {
   action_back:"Back", 
   action_confirm: "Confirm",
   action_next: "Next",
}


const defaultFullAddres = {
  address:undefined, 
  geopoint: {latitude:undefined, longitude: undefined}, 
  details: undefined,
}; 

const isPlaceOK  = (fullAddress)=>{
  if(!fullAddress)
      return false; 
   const hasAddress =  fullAddress.address && fullAddress.address.length>5; 
   return hasAddress; 
}

const parseToPlace = (newPlace)=>{
     const selectedPlace = {};
     selectedPlace.address = newPlace.formatted_address; 
     selectedPlace.details = ""; 
     selectedPlace.placeId = newPlace.place_id

     if(newPlace.geometry && newPlace.geometry.location){
        const geopoint = {
            latitude:newPlace.geometry.location.lat(),
            longitude: newPlace.geometry.location.lng(),
        }
        selectedPlace.geopoint = geopoint; 
     }
   return selectedPlace; 
}




export default function AddressPage(props) {
  const classes = useStyles();
  let {strings} = props; 
  strings = !strings ? defaultStrings: strings; 
  const {onCancel,
     onFinish,
     defaultAddress,
     defaultPickup,
     store,
     title,
     dataSource,
     type
    } = props; 
  
   const refFullAddress =  useRef(defaultAddress ? defaultAddress: defaultFullAddres); 

  const [search, setSearch] = useState(true);
  const [placeOk, setPlaceOK] = useState(isPlaceOK(refFullAddress.current)); 
  const [error, setError] = useState(null);
  const listFiltered = dataSource.listFiltered(refFullAddress.current);  
  const [list, setList] = useState(listFiltered); 

  const refCurrentPosition = useRef(null); 
  const [searchBox, setSearchBox] = useState(null)
  const [library, setLibrary] = useState(false); 
  

  useEffect(async() => {

  async function fetchData() {    
      log.message("AddressPage","Starting useEffect"); 
      const loader = new Loader({
        apiKey: "AIzaSyBbkpSVjRQjSZ0-VHwzoMcGQyX1EAIrbYo",
        version: "weekly",
      });
  
     await loader.importLibrary("places").then(async () => {
      log.message("AddressPage","importLibrary places loaded");
        setLibrary(true)
     })

     log.message("AddressPage","import ok ");

     let radio=0.4; let newPosition; 

     if(refCurrentPosition.current){
         newPosition = refCurrentPosition.current; 
         log.message("AddressPage","GeoLocation by ref:", newPosition);
     }else{
        newPosition = await getCurrentGeoLocation();
         log.message("AddressPage","GeoLocation by getCurrentGeoLocation(): ",newPosition);
     }     
     
     if(!newPosition){
        newPosition =  store.geopoint;
        newPosition.type="store"; 
        radio =0.8; 
        log.message("AddressPage","default GeoLocation:  store.geopoint", newPosition);
     }
  
    const userBox= getBoundingBox(newPosition,radio); 
    //log.message("AddressPage","getBoundingBox", userBox);
    setSearchBox(userBox)
    refCurrentPosition.current = newPosition;
    log.message("AddressPage","end newPosition",refCurrentPosition.current);
  }

  await fetchData(); 
  log.message("AddressPage","refCurrentPosition",  refCurrentPosition.current);
  }, []);


  const getControlAddress = ()=>{
    let refaddres; 
    if(type=="address"){
      refaddres = defaultPickup
    } else  if(type=="pickup"){
      refaddres = defaultAddress
    }
    return refaddres
  }

  const onSelectedAddress = (newPlace) => {
    //console.debug("AddressPage: onSelectedAddress:", newPlace);
     if(newPlace ==  refFullAddress.current){
       //console.debug("AddressPage: onSelectedAddress equasl"); 
       return;
     }
     const selectedPlace =parseToPlace(newPlace);
     selectedPlace.type = "google"
     setError(null);
     checkDistanceOK(selectedPlace);
     updateForm(selectedPlace);
  };

    const checkDistanceOK = (selectedPlace)=>{
      const maxDistance = store.maxDistance; 
      const addressReference = getControlAddress()
      let  distance = 0; 
      
      if( addressReference && selectedPlace.geopoint && addressReference.geopoint)
         distance = getDistance(selectedPlace.geopoint,addressReference.geopoint);
    
      //console.debug(`AddressPage: distance=${distance.toFixed(2)}, maxDistance=${maxDistance}`);
      if(distance>maxDistance){
        setErrorDistance(distance,maxDistance)
        return false; 
      }
      return true; 
    }


    const setErrorDistance=(distance,maxDistance)=>{
      let str = strings.error_out_of_range; 
      let message = str
      .replace("${store}",maxDistance)
      .replace("${user}", distance.toFixed(2));
      //console.debug("AddressPage: ErrorDistance:", message);
      setError({
        message: message,
        code:"maxDistance",
      })
    }

    const updateForm = (fullAddress)=>{
      //console.debug("updateForm:", fullAddress);
      refFullAddress.current = fullAddress;
      setPlaceOK(isPlaceOK(fullAddress)); 
      let newList = dataSource.listFiltered(fullAddress)
      setList(newList)
    }


  const onClickInput = () => {
   
  };

  const onChangeAutoInput = (value) => {
    //console.debug("onChangeAutoInput:",value); 
    setError(null);
    const newAddress = {...refFullAddress.current}; 
    newAddress.address=value; 
    newAddress.geopoint= undefined
    newAddress.type = 'edited'
    updateForm(newAddress);
  }; 

  const onChangeDetailsInput = (value) => {
     const newAddress = {...refFullAddress.current}; 
     newAddress.details=value; 
     updateForm(newAddress); 
  }; 

  const handlerNext = () => {
    log.message("AddressPage","handlerNext refCurrentPosition",  refCurrentPosition.current);
      setSearch(false);
  }

  const handlerBackToPlace = () => {
    //console.debug("handlerCancel");
    setSearch(true);
  }

  const handlerFinish = (address) => {
    const fullAddress = {...address};
    setError(null);
    if(checkDistanceOK(fullAddress)){
      dataSource.add(fullAddress)
      //console.debug("AddressPage: onFinish", fullAddress);
      if(onFinish)
       onFinish(fullAddress);
    }else{
       setSearch(true); 
       updateForm(fullAddress);
    }

  }

  const handlerCancel = () => {
    //console.debug("AddressPage: Cancel");
    if(!onCancel) return; 
    onCancel(); 
  }

  const handlerIconColor = ()=>{
    if(!refFullAddress.current.geopoint){
      return 'disabled'; 
    }

    if(error && error.code ==="maxDistance")
        return 'error'; 
     return placeOk? 'accent':'disabled'
  }
  
  const handlerOnClickDelete = (address)=>{
    //console.debug("AddressPage: onClick Delete Address:",address); 
    dataSource.remove(address)
    const newList = dataSource.listFiltered(refFullAddress.current)
    setList(newList);
  }

  const handlerOnClickItemAddress = (address) =>{
    setError(null);
    checkDistanceOK(address); 
    updateForm(address);
  }

  return (
    <div className = {classes.containerPage}>   
          { search && 
            <div className={classes.paddingSearch}></div>
          }

          {
           search && 
            <div >
              <Paper    className={classes.containerSearch} elevation={3}>
                {library &&  
                  <AutoCompleteAddress
                      onSelectedAddress={onSelectedAddress}
                      onClickInput={ onClickInput}
                      onChangeDetailsInput= {onChangeDetailsInput}
                      onChangeInput={onChangeAutoInput}
                      bounds = {searchBox}
                      fullAddress={refFullAddress.current}
                      strings = {strings}
                      autoIconColor = {handlerIconColor()}
                      autoTitle={title}
                  />  
                }         
              </Paper>

              

              <div className = {classes.scrollable}>
                    {error && 
                      <div className = {classes.containerError}>   
                        <WarnningBox
                          message={error.message}
                        />
                    </div>
                    }
                    {list && list.length !== 0 && 
                      <Paper className = {classes.containerAddressList}  elevation={2}>
                        <Typography className={classes.titleList}>{strings.title_list_address}</Typography>
                        <Divider/>
                      <List className = {classes.list}>
                      {list.map((item, index)=>(
                        
                        <div key= {index}>
                        <OutputAddress         
                          fullAddress={item}
                          onClickDelete={handlerOnClickDelete}
                          onClickAddress = {handlerOnClickItemAddress}
                        />
                        {
                          index < list.length-1 && <Divider className = {classes.divider} />
                        }
                        </div>
                        
                      ))}
                    </List>
                    </Paper>
                    }
               </div>
            </div>
          }           
           

          { search &&         
                        <PanelButtons                    
                        onClickCancel={handlerCancel}
                        onClickNext={handlerNext}
                        labelCancel={strings.action_back}
                        labelNext={strings.action_next}
                        nextDisabled = {error!=null || !placeOk }
                        />    
          }

          {!search && refCurrentPosition.current &&
            <CoordinatesView
              strings = {strings}
              title = {strings.map_coordinates}
              onCancel = {handlerBackToPlace}  
              onFinish = {handlerFinish}
              defaultAddress ={refFullAddress.current}            
              requiresGeopoint={true} 
              refGeopoint = {getControlAddress()? getControlAddress().geopoint: undefined}
              refMaxDistance = {store.maxDistance}
              userPosition = {refCurrentPosition.current}
            />
          }
    </div>
  );
}
